import type { AxiosInstance } from "axios";
import axiosInstance from "@/lib/util/axios";
import type { Cohort, CohortWorkspaceApi } from "./types";

interface CohortsResponse { cohorts: Cohort[]; }

export const createCohortWorkspaceApi = (
  client: Pick<AxiosInstance, "get"> = axiosInstance,
): CohortWorkspaceApi => ({
  async listCohorts() {
    const { data } = await client.get<CohortsResponse>("/api/cohorts");
    return data.cohorts;
  },
});

export const cohortWorkspaceApi = createCohortWorkspaceApi();
